import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { passwordLogin } from '../../utils/apiClient';
import { saveAuthSession, isLoggedIn } from '../../utils/session';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [loggingIn, setLoggingIn] = useState(false);
  const [statusHint, setStatusHint] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const afterLoginPath = () => {
    const from = location.state && location.state.from;
    return typeof from === 'string' && from.startsWith('/') && from !== '/login' ? from : '/home';
  };

  useEffect(() => {
    if (isLoggedIn()) {
      navigate(afterLoginPath(), { replace: true });
    }
  }, [navigate, location.state]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!agreed) {
      alert('请先阅读并同意用户协议与隐私政策');
      return;
    }
    const u = username.trim();
    const p = password;
    if (!u || !p) {
      setStatusHint('请输入账号和密码');
      return;
    }
    setLoggingIn(true);
    setStatusHint('');
    try {
      const data = await passwordLogin(u, p);
      if (data && data.token) {
        saveAuthSession({
          token: data.token,
          user: data.user || { username: u },
        });
        navigate(afterLoginPath(), { replace: true });
      } else {
        setStatusHint('登录失败：未返回令牌');
      }
    } catch (err) {
      setStatusHint(err.message || '登录失败');
    } finally {
      setLoggingIn(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="background-image"></div>
        <div className="login-card">
          <div className="login-header">
            <div className="logo-container">
              <img src="/images/logo.png" alt="湖南迪亚环境工程股份有限公司" className="company-logo" />
            </div>
            <h1 className="login-title">湖南迪亚环境工程股份有限公司运营指挥中心</h1>
            <p className="login-subtitle">营造绿色未来 · 共创碧水蓝天</p>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            {statusHint ? (
              <p className="auth-status-hint status-error">{statusHint}</p>
            ) : null}

            <div className="form-group">
              <label htmlFor="username">账号</label>
              <input
                id="username"
                type="text"
                className="form-input"
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="请输入账号"
                disabled={loggingIn}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">密码</label>
              <input
                id="password"
                type="password"
                className="form-input"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="请输入密码"
                disabled={loggingIn}
              />
            </div>

            <label className="agreement-row">
              <input
                type="checkbox"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
                disabled={loggingIn}
              />
              <span>我已阅读并同意用户协议与隐私政策</span>
            </label>

            <button
              type="submit"
              className={`login-button ${loggingIn ? 'loading' : ''}`}
              disabled={!agreed || loggingIn}
            >
              {loggingIn ? '登录中…' : '登录'}
            </button>
          </form>

          <div className="login-footer">
            <p className="footer-text">© 湖南迪亚环境工程股份有限公司</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
